export default {
    // --------Title--------
    properties: '属性',
    detailOfTheInjectionProps: '注入参数详细信息',

    // --------MUI--------
    mainProperty: '主要属性',
    module: '模块',
    reference: '参考',
    fieldType: '类型',
    propKey: '属性键',
    isMultiple: '多选项',
    usedNo: '已用编号',
    browseProps: '浏览属性',

    singleValue: '单值',
    moduleReference: '模块参考',
    moduleType: '模块类型',
    refFieldValue: '参考值',
    propValue: '属性值',

};